<template>
  <div class="login-container">
    <div class="login-panel">
      <div class="login-form-container">
        <div style="margin-bottom: 20px" v-if="reviewStatus!==1">
          <el-card class="box-card">
            <!-- 审核中 -->
            <div v-if="reviewStatus === 0" class="review-pending">
              <h3>店铺审核中</h3>
              <p style="margin-top: 10px">您的店铺正在审核中，请耐心等待...</p>
            </div>
            <!-- 审核未通过 -->
            <div v-else-if="reviewStatus === 2">
              <h3>店铺审核未通过</h3>
              <p>很抱歉，您的店铺审核未通过</p>
              <div class="rejection-reason">
                <h4>未通过原因：</h4>
                <div class="reason-content">{{ reason || '暂无具体原因，请联系客服' }}</div>
              </div>
            </div>
          </el-card>

        </div>
        <el-form
            ref="registerForm"
            :model="registerForm"
            :rules="registerRules"
            class="login-form"
            @submit.native.prevent="handleRegister"
        >
          <!-- 公司名称 -->
          <el-form-item prop="name" required>
            <el-input
                v-model="registerForm.name"
                placeholder="请输入您的公司名称"
                prefix-icon="el-icon-office-building"
                size="large"
                clearable

            />
          </el-form-item>

          <!-- 营业执照编号 -->
          <el-form-item prop="businessLicense" required>
            <el-input
                v-model="registerForm.businessLicense"
                placeholder="请输入营业执照注册号"
                size="large"
                clearable
            />
          </el-form-item>
          <el-form-item  required>
            <!-- 营业执照上传 -->
            <div class="upload-section">
              <label class="upload-label">营业执照上传(必传)</label>
              <el-upload
                  action="#"
                  class="upload-demo"
                  :file-list="liceneList"
                  accept="image/*"
                  :limit="1"
                  :on-remove="handleRemoveLicense"
                  :http-request="handleLicenseUpload"
                  list-type="picture-card"
              >
                <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过10MB
                </div>
              </el-upload>
            </div>
          </el-form-item>

          <!-- 商标注册证书号 -->
          <el-form-item prop="trademarkReg">
            <el-input
                v-model="registerForm.trademarkReg"
                placeholder="请输入商标注册证书号（选填）"
                size="large"
                clearable
            />
          </el-form-item>

          <!-- 商标上传 -->
          <el-form-item>
            <label class="upload-label">商标注册证上传（选填）</label>
            <el-upload
                action="#"
                class="upload-demo"
                :file-list="trademarkList"
                accept="image/*"
                :limit="1"
                :on-remove="handleRemoveTrademark"
                :http-request="handleTrademarkUpload"
                list-type="picture-card"
            >
              <div class="el-upload__tip" slot="tip">
                只能上传jpg/png文件，且不超过10MB
              </div>
            </el-upload>
          </el-form-item>

          <!-- 注册按钮 -->
          <el-form-item>
            <el-button
                type="primary"
                size="large"
                class="login-button register-button"
                :loading="registerLoading"
                @click="handleRegister"
            >
              {{ registerLoading ? '编辑中...' : '确定' }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {register, updateShop} from '@/api/login'
import {getShop, getUpdateFileUrl} from '@/api'
import {v4 as uuidv4} from 'uuid'
import axios from 'axios'

export default {
  name: 'Register',
  data() {
    return {
      reviewStatus: null,
      reason: '',
      liceneList: [],
      trademarkList: [],
      shopId: '',
      userInfo: {},
      registerForm: {
        name: '',
        businessLicense: '',
        trademarkReg: '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreement: false,
        licenseFile: null,
        trademarkFile: null,
      },
      registerRules: {
        name: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
          {min: 2, max: 50, message: '公司名称长度在2-50个字符', trigger: 'blur'},
        ],
        businessLicense: [
          {required: true, message: '请输入18位营业执照编号', trigger: 'blur'},
          {min: 18, max: 18, message: '营业执照编号长度为18位', trigger: 'blur'},
        ],
      },
      registerLoading: false,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('user_info'))
    this.shopId = this.userInfo.shopId
    getShop(this.shopId).then(res => {
      this.registerForm = res.data
      // 如果已有文件，可以初始化 file-list
      if (res.data.licenseFile) {
        this.liceneList = [{name: '营业执照', url: res.data.licenseFile}]
      }
      if (res.data.trademarkFile) {
        this.trademarkList = [{name: '商标证', url: res.data.trademarkFile}]
      }
      this.reviewStatus = res.data.reviewStatus
      this.reason = res.data.reason
    })
  },
  methods: {
    async handleRegister() {
      this.$refs.registerForm.validate(async valid => {
        if (!valid) return
        if (!this.registerForm.licenseFile) {
          this.$message.warning('请上传营业执照')
          return
        }
        this.registerLoading = true
        try {
          const registerData = {
            id: this.shopId,
            name: this.registerForm.name,
            businessLicense: this.registerForm.businessLicense,
            trademarkReg: this.registerForm.trademarkReg,
            licenseFile: this.registerForm.licenseFile,
            trademarkFile: this.registerForm.trademarkFile,
          }
          const response = await updateShop(registerData)
          if (response.code === 200) {
            this.$message.success('已经提交审核，请联系您的销售顾问')
            this.registerForm = response.data
            this.$emit('registerSuccess', 1)
          } else {
            this.$message.error(response.msg)
          }
        } catch (err) {
          console.error(err)
          this.$message.error(err.message || '注册失败，请重试')
        } finally {
          this.registerLoading = false
        }
      })
    },

    resetRegisterForm() {
      this.registerForm = {
        name: '',
        businessLicense: '',
        trademarkReg: '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreement: false,
        licenseFile: null,
        trademarkFile: null,
      }
      this.liceneList = []
      this.trademarkList = []
      this.$refs.registerForm && this.$refs.registerForm.resetFields()
    },

    // 上传营业执照
    async handleLicenseUpload({file, onSuccess, onError}) {
      try {
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error('文件大小不能超过10MB！')
          return
        }
        const uuid = uuidv4()
        const ext = file.name.split('.').pop()
        const uploadUrlResponse = await getUpdateFileUrl(uuid + '.' + ext, 'shop')
        if (!uploadUrlResponse || uploadUrlResponse.code !== 200) {
          throw new Error('获取上传URL失败')
        }
        const putUrl = uploadUrlResponse.data.putUrl
        await axios.put(putUrl, file, {headers: {'Content-Type': 'application/octet-stream'}})

        const fileUrl = putUrl.split('?')[0]
        this.registerForm.licenseFile = fileUrl
        this.liceneList = [{name: file.name, url: fileUrl}]

        onSuccess(file)
      } catch (err) {
        this.$message.error(err.message || '上传失败')
        onError(err)
      }
    },

    handleRemoveLicense() {
      this.registerForm.licenseFile = null
      this.liceneList = []
    },

    // 上传商标证
    async handleTrademarkUpload({file, onSuccess, onError}) {
      try {
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error('文件大小不能超过10MB！')
          return
        }

        const uuid = uuidv4()
        const ext = file.name.split('.').pop()
        const uploadUrlResponse = await getUpdateFileUrl(uuid + '.' + ext, 'shop')
        if (!uploadUrlResponse || uploadUrlResponse.code !== 200) {
          throw new Error('获取上传URL失败')
        }
        const putUrl = uploadUrlResponse.data.putUrl
        await axios.put(putUrl, file, {headers: {'Content-Type': 'application/octet-stream'}})

        const fileUrl = putUrl.split('?')[0]
        this.registerForm.trademarkFile = fileUrl
        this.trademarkList = [{name: file.name, url: fileUrl}]

        onSuccess(file)
      } catch (err) {
        this.$message.error(err.message || '上传失败')
        onError(err)
      }
    },

    handleRemoveTrademark() {
      this.registerForm.trademarkFile = null
      this.trademarkList = []
    },
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

.login-panel {
  flex: 1;
  background: white;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  overflow-y: auto;
  box-shadow: -10px 0 50px rgba(0, 0, 0, 0.1);
}

.login-form-container {
  width: 100%;
  max-width: 480px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload-label {
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 12px;
  font-weight: 600;
}
</style>
